import { HttpParams } from "@angular/common/http";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router, RoutesRecognized } from "@angular/router";
// import { CookieService } from "ngx-cookie-service";
// import { NgcCookieConsentService, NgcInitializeEvent, NgcNoCookieLawEvent, NgcStatusChangeEvent } from "ngx-cookieconsent";
import { Subscription } from "rxjs";
import { fadeAnimation } from "./animations";
import { CookiesService } from "./core-services/cookie.service";
import { UtmParameters } from "./models/UtmParametersModel";

@Component({
  selector: "app-root",
  template: `
  <app-enquiry-sidebar></app-enquiry-sidebar>
    <router-outlet></router-outlet>
    <ngx-spinner
      bdColor="rgba(51,51,51,0.8)"
      size="medium"
      color="#fff"
      type="ball-scale-multiple" >
      <p style="font-size: 20px; color: white"></p>
    </ngx-spinner>
  `,
  animations: []
})
export class AppComponent implements OnInit, OnDestroy {

  title = "app";
  utmParameters: UtmParameters;
  private popupOpenSubscription: Subscription;
  private popupCloseSubscription: Subscription;
  private initializeSubscription: Subscription;
  private statusChangeSubscription: Subscription;
  private revokeChoiceSubscription: Subscription;
  private noCookieLawSubscription: Subscription;

  constructor(private cookieService: CookiesService, private router: Router) {

  }

  ngOnInit() {
    this.router.events.subscribe(val => {
      if (val instanceof RoutesRecognized) {
        if (val.state.root.firstChild.queryParams.utm_source && !this.cookieService.getCookie('utmparam')) {
          let paramsCopy = Object.assign({}, val.state.root.firstChild.queryParams);
          delete paramsCopy.utm_source;
          delete paramsCopy.utm_medium;
          delete paramsCopy.utm_campaign;
          delete paramsCopy.utm_term;
          delete paramsCopy.utm_content;
          this.utmParameters = new UtmParameters();
          this.utmParameters.utmSource = val.state.root.firstChild.queryParams['utm_source'];
          this.utmParameters.utmMedium = val.state.root.firstChild.queryParams['utm_medium'];
          this.utmParameters.utmCampaign = val.state.root.firstChild.queryParams['utm_campaign'];
          this.utmParameters.utmTerm = val.state.root.firstChild.queryParams['utm_term'];
          this.utmParameters.utmContent = val.state.root.firstChild.queryParams['utm_content'];
          this.cookieService.setCookie('utmparam', JSON.stringify(this.utmParameters), 14);
          this.router.navigate(
            [val.url.substring(0, val.url.indexOf('?'))],
            {
              queryParams: paramsCopy,
              queryParamsHandling: 'merge',
            });

        }
      }
    });

    // this.popupOpenSubscription = this.ccService.popupOpen$.subscribe(
    //   () => {
    //   });

    // this.popupCloseSubscription = this.ccService.popupClose$.subscribe(
    //   () => {
    //   });

    // this.initializeSubscription = this.ccService.initialize$.subscribe(
    //   (event: NgcInitializeEvent) => {
    //   });

    // this.statusChangeSubscription = this.ccService.statusChange$.subscribe(
    //   (event: NgcStatusChangeEvent) => {
    //   });

    // this.revokeChoiceSubscription = this.ccService.revokeChoice$.subscribe(
    //   () => {
    //   });

    // this.noCookieLawSubscription = this.ccService.noCookieLaw$.subscribe(
    //   (event: NgcNoCookieLawEvent) => {
    //   });
  }

  ngOnDestroy() {
    this.popupOpenSubscription.unsubscribe();
    this.popupCloseSubscription.unsubscribe();
    this.initializeSubscription.unsubscribe();
    this.statusChangeSubscription.unsubscribe();
    this.revokeChoiceSubscription.unsubscribe();
    this.noCookieLawSubscription.unsubscribe();
  }
}
